"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _pincode;

var _actions = require("egov-ui-kit/redux/form/actions");

var _get = require("lodash/get");

var _get2 = _interopRequireDefault(_get);

var _set = require("lodash/set");

var _set2 = _interopRequireDefault(_set);

var _localStorageUtils = require("egov-ui-kit/utils/localStorageUtils");

var _commons = require("egov-ui-kit/utils/commons");

var _actions2 = require("egov-ui-kit/redux/app/actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//const tenantId = JSON.parse(getUserInfo()).permanentCity;
var tenantId = "km.kolkata";
var formConfig = {
  name: "complaint",
  idJsonPath: "services[0].serviceRequestId",
  fields: {
    media: {
      id: "media",
      jsonPath: "actionInfo[0].media",
      file: true,
      errorMessage: "Upload Failed"
    },
    departmentname: {
      id: "departmentname",
      jsonPath: "services[0].departmentname"
    },
    category: {
      id: "category",
      required: true,
      jsonPath: "services[0].category",
      floatingLabelText: "Category",
      errorMessage: "Select Category",
      hintText: "Select Category"
    },
    subCategory: {
      id: "subCategory",
      required: true,
      jsonPath: "services[0].subCategory",
      floatingLabelText: "Sub Category",
      errorMessage: "Select Sub Category",
      hintText: "Select Sub Category"
    },
    department: {
      id: "department",
      required: true,
      jsonPath: "services[0].department",
      floatingLabelText: "CS_ADDCOMPLAINT_DEPARTMENT",
      hintText: "HR_DEPARTMENT_PLACEHOLDER",
      errorMessage: "HR_DEPARTMENT_PLACEHOLDER",
      boundary: true,
      dropDownData: [],
      updateDependentFields: function updateDependentFields(_ref) {
        var formKey = _ref.formKey,
            field = _ref.field,
            dispatch = _ref.dispatch,
            state = _ref.state;

        if (field && field.value) {
          dispatch((0, _actions.setFieldProperty)("complaint", "complaintType", "disabled", false));
        } else {
          dispatch((0, _actions.setFieldProperty)("complaint", "complaintType", "disabled", true));
        }
        dispatch((0, _actions.setFieldProperty)("complaint", "complaintType", "value", ""));
      },
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorText: ""
    },
    ward: {
      id: "ward",
      required: true,
      jsonPath: "services[0].addressDetail.ward",
      floatingLabelText: "Locality/Ward",
      hintText: "CS_CREATECOMPLAINT_MOHALLA_PLACEHOLDER",
      errorMessage: "CS_ADDCOMPLAINT_COMPLAINT_TYPE_PLACEHOLDER",
      boundary: true,
      dropDownData: [],

      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorText: ""
    },
    streetName: {
      id: "streetName",
      required: true,
      jsonPath: "services[0].addressDetail.streetName",
      floatingLabelText: "Street Name",
      hintText: "Select Street",
      errorMessage: "CS_ADDCOMPLAINT_COMPLAINT_TYPE_PLACEHOLDER",
      boundary: true,
      dropDownData: []
    },
    complaintType: {
      id: "complaint-type",
      jsonPath: "services[0].serviceCode",
      required: true,
      floatingLabelText: "CS_ADDCOMPLAINT_COMPLAINT_TYPE",
      errorMessage: "CS_ADDCOMPLAINT_COMPLAINT_TYPE_PLACEHOLDER",
      hintText: "CS_ADDCOMPLAINT_COMPLAINT_TYPE_PLACEHOLDER"
    },
    premise: {
      id: "premise-no",
      jsonPath: "services[0].addressDetail.premise",
      required: false,
      floatingLabelText: "Premise Number",
      errorMessage: "Enter Premise Number",
      hintText: "Enter Premise Number"
    },
    pincode: (_pincode = {
      id: "pin-code",
      pattern: "^700[0-9]{3}$",
      errorMessage: "Invalid Pincode",
      jsonPath: "services[0].addressDetail.pincode",
      required: true,
      floatingLabelText: "Pin Code"
    }, (0, _defineProperty3.default)(_pincode, "errorMessage", "Invalid Pincode"), (0, _defineProperty3.default)(_pincode, "hintText", "Enter Pin Code"), _pincode),
    localps: {
      id: "localps",
      jsonPath: "services[0].addressDetail.localps",
      errorMessage: "Please Select Local Ps"
    },
    hqps: {
      id: "hqps",
      jsonPath: "services[0].addressDetail.hqps",
      errorMessage: "Please Select Hq Ps"
    },
    borough: {
      id: "borough",
      jsonPath: "services[0].addressDetail.borough",
      errorMessage: "Please Select Borough"
    },
    additionalDetails: {
      id: "additional details",
      jsonPath: "services[0].description",
      floatingLabelText: "Details of Grievance",
      hintText: "CS_ADDCOMPLAINT_COMPLAINT_DETAILS_PLACEHOLDER",
      errorMessage: "CS_ADDCOMPLAINT_COMPLAINT_DETAILS_VALIDATION",
      pattern: /^[^\$\"'<>\?~`!&@#$%^+={}\[\]*:;]{1,500}$/i,
      maxlength: "500"
    },
    // citizenMobileNo: {
    //   id: "citizen-mobile-no",
    //   jsonPath: "services[0].citizenMobileNo",
    //   floatingLabelText: "Citizen Mobile No",
    //   hintText: "Citizen Mobile No",
    //   errorMessage: "Invaid Mobile No",
    //   pattern: /^([0-9]){10}/i,
    //   maxlength: "500",
    // },
    latitude: {
      id: "latitude",
      jsonPath: "services[0].addressDetail.latitude"
    },
    longitude: {
      id: "longitude",
      jsonPath: "services[0].addressDetail.longitude"
    },
    address: {
      id: "address",
      required: true,
      jsonPath: "services[0].addressDetail.address",
      floatingLabelText: "Address",
      hintText: "Enter Address"
    },
    residenceAddress: {
      id: "residenceAddress",
      required: true,
      jsonPath: "services[0].addressDetail.residenceAddress",
      floatingLabelText: "Residential Address of the Complaintant",
      hintText: "Enter Address"
    },
    email: {
      id: "emailId",
      pattern: /^(([^<>()\[\]\\.,;:\s$*@'"]+(\.[^<>()\[\]\\.,;:\s@'"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      errorMessage: "Invalid Email",
      jsonPath: "services[0].email",
      floatingLabelText: "Email Id",
      hintText: "Enter Email Id"
    },
    city: {
      id: "city",
      jsonPath: "services[0].addressDetail.city",
      floatingLabelText: "CORE_COMMON_CITY",
      hintText: "ES_CREATECOMPLAINT_SELECT_PLACEHOLDER",
      errorMessage: "CS_ADDCOMPLAINT_COMPLAINT_TYPE_PLACEHOLDER",
      required: true,
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorText: "",
      dropDownData: [],
      updateDependentFields: function updateDependentFields(_ref2) {
        //   dispatch(setFieldProperty("complaint", "mohalla", "value", ""));

        var formKey = _ref2.formKey,
            field = _ref2.field,
            dispatch = _ref2.dispatch,
            state = _ref2.state;
      },
      beforeFieldChange: function beforeFieldChange(_ref3) {
        var action = _ref3.action,
            dispatch = _ref3.dispatch,
            state = _ref3.state;

        if ((0, _get2.default)(state, "common.prepareFormData.services[0].addressDetail.city") !== action.value) {
          var moduleValue = action.value;
          dispatch((0, _actions2.fetchLocalizationLabel)((0, _localStorageUtils.getLocale)(), moduleValue, moduleValue));
        }
        return action;
      },
      labelsFromLocalisation: true

    },

    houseNo: {
      id: "houseNo",
      jsonPath: "services[0].addressDetail.houseNoAndStreetName",
      floatingLabelText: "CS_ADDCOMPLAINT_HOUSE_NO",
      hintText: "CS_ADDCOMPLAINT_HOUSE_NO_PLACEHOLDER",
      errorMessage: "CS_HOUSE_NO_ERROR_MESSAGE_VALIDATION",
      //errorMessage: "CS_ADDCOMPLAINT_COMPLAINT_DETAILS_VALIDATION",
      pattern: /^[^\$\"'<>\?~`!&@#$%^+={}\[\]*:;]{1,100}$/i
    },
    landmark: {
      id: "landmark",
      jsonPath: "services[0].addressDetail.landmark",
      floatingLabelText: "Landmark",
      hintText: "Enter Landmark",
      errorMessage: "CS_ADDCOMPLAINT_LANDMARK_VALIDATION",
      // errorMessage: "CS_ADDCOMPLAINT_COMPLAINT_DETAILS_VALIDATION",
      pattern: /^[^\$\"'<>\?~`!&@#$%^+={}\[\]*:;]{1,100}$/i
    },
    tenantId: {
      id: "add-complaint-tenantid",
      jsonPath: "services[0].tenantId"
    },
    phone: {
      id: "phone",
      jsonPath: "services[0].phone"
    },
    roleType: {
      id: "roleType",
      jsonPath: "services[0].roleType",
      value: "CITIZEN"
    },
    fullName: {
      id: "fullName",
      jsonPath: "services[0].fullName",
      value: JSON.parse(localStorage.getItem("Citizen.user-info")).name
    }
  },
  submit: {
    type: "submit",
    label: "CS_ADDCOMPLAINT_ADDITIONAL_DETAILS_SUBMIT_COMPLAINT",
    id: "addComplaint-submit-complaint"
  },
  afterInitForm: function afterInitForm(action, store, dispatch) {
    try {
      var state = store.getState();
      var localizationLabels = state.app.localizationLabels;
      var _state$common = state.common,
          cities = _state$common.cities,
          citiesByModule = _state$common.citiesByModule;
      var _state$complaints = state.complaints,
          categoriesById = _state$complaints.categoriesById,
          complaintDepartment = _state$complaints.complaintDepartment,
          wardById = _state$complaints.wardById,
          complaintSector = _state$complaints.complaintSector;

      var _ref4 = citiesByModule || {},
          PGR = _ref4.PGR;

      if (PGR) {
        // for department
        var arrayOfDepartment = [];
        var i = 0;
        var getNestedObjFormat = function getNestedObjFormat(categories) {
          var categoryList = {};
          Object.values(categories).map(function (item) {
            (0, _set2.default)(categoryList, item.code, item);
          });
          return transform(categoryList);
        };

        var transform = function transform(input) {
          return Object.keys(input).reduce(function (result, itemKey) {
            var item = Object.assign({}, input[itemKey]);
            if (item && item.code) {
              if (item.code != "udefined") {
                var duplicate_flag = arrayOfDepartment.find(function (ele) {
                  return ele.value === item.code;
                });
                var DepLable = "";
                if (!duplicate_flag) {
                  var codevalue = "" + item.code;
                  if (codevalue.includes("DEP")) {
                    DepLable = "PGRDEPT." + item.code.toUpperCase();
                  } else {
                    DepLable = item.name;
                  }

                  arrayOfDepartment.push({ label: (0, _commons.getTranslatedLabel)(DepLable, localizationLabels), value: item.code });
                }
              }
              i++;
            }
            return result;
          }, []);
        };

        var categoryList = getNestedObjFormat(complaintDepartment);
        dispatch((0, _actions.setFieldProperty)("complaint", "department", "dropDownData", arrayOfDepartment));
        arrayOfDepartment = [];
        var sectorList = getNestedObjFormat(wardById);
        dispatch((0, _actions.setFieldProperty)("complaint", "ward", "dropDownData", arrayOfDepartment));

        var department = (0, _get2.default)(state, "form.complaint.fields.department");
        if (department && department.value) dispatch((0, _actions.setFieldProperty)("complaint", "complaintType", "disabled", false));else dispatch((0, _actions.setFieldProperty)("complaint", "complaintType", "disabled", true));

        var tenants = PGR.tenants;
        var dd = tenants.reduce(function (dd, tenant) {
          var selected = cities.find(function (city) {
            return city.code === tenant.code;
          });
          if (selected) {
            var label = "TENANT_TENANTS_" + selected.code.toUpperCase().replace(/[.]/g, "_");
            dd.push({ label: (0, _commons.getTranslatedLabel)(label, localizationLabels), value: selected.code });
          }

          return dd;
        }, []);
        dispatch((0, _actions.setFieldProperty)("complaint", "city", "dropDownData", dd));
      }
      var city = (0, _get2.default)(state, "form.complaint.fields.city.value");
      // let mohalla = get(state, "form.complaint.fields.mohalla.value");
      if (!city) {
        dispatch((0, _actions.handleFieldChange)("complaint", "city", tenantId));
      } else {
        if (city) {
          dispatch((0, _actions.handleFieldChange)("complaint", "city", city));
        }
        if (ward) {
          // dispatch(handleFieldChange("complaint", "mohalla", mohalla));
        }
      }
      return action;
    } catch (e) {
      console.log(e);
    }
  },
  action: "_create",
  saveUrl: "/rainmaker-pgr/v1/requests/_create",
  redirectionRoute: "/complaint-submitted"
};

exports.default = formConfig;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/config/forms/specs/pgr/pgr-citizen/complaint.js
// module id = 2089
// module chunks = 1137